import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Pagination from "react-js-pagination";
import ContentIcon, { HEADING_WEBVIEW } from "ContentIcon";
import { fetchProposal, searchProposal } from "ProposalAction";
import { fetchEventDetails } from "DashboardUserAction";
import {
  openDashboardUserModal,
  fetchUsersCategory,
  editDashboardUser,
} from "DashboardUserAction";
import { screenHeightLeftFromTop } from "Constants";
import ProposalItem from "./proposal-item-list";
import AddReviewer from "./add-reviewer";
import ManageProposal from "./manage-proposal";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNumber: 1,
      search: "",
      proposalid: "",
      addreviewer: false,
      loading: true,
      desc: "Abstract Dashboard",
    };
  }

  componentDidMount() {
    this.props.fetchUsersCategory(this.props.session);
    this.props.fetchEventDetails(this.props.session);
    this.props.fetchProposal(this.props.session, (callback) => {
      this.setState({ loading: false });
    });
  }

  renderProposalList = () => {
    let pageDataLength = this.props.proposalList.data.length;
    let { pageNumber } = this.state;

    return _.map(this.props.proposalList.data, (proposal) => {
      return (
        <ProposalItem
          key={proposal.id}
          proposal={proposal}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
          openModal={this.openModal}
          closeModal={this.closeModal}
        />
      );
    });
  };

  onSearchProposal = (event) => {
    var search = event.target.value;
    let pageNumber = 1;
    if (search == "") {
      this.props.fetchProposal(this.props.session, (callback) => {});
    } else {
      this.props.searchProposal(
        this.props.session,
        search,
        pageNumber,
        0,
        (callback) => {}
      );
    }
    this.setState({ search, pageNumber });
  };

  render() {
    var { deviceSize, proposalList } = this.props;
    let options = [];
    options.push(<option value="">{LocaleStrings.proposal_filter}</option>);
    options.push(
      <option key="name" value="name">
        Name
      </option>
    );

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <div>
              <div className="tickets-heading">
                {LocaleStrings.proposal_heading}
              </div>
              <div className="custom-text2-secondary-normal subtext-tabhidden">
                {LocaleStrings.proposal_subheading}
              </div>
            </div>
          </div>

          <ul className="header-buttons">
            {/* <li className="users-button">
                <select
                  // className="form-control"
                  onChange={(e) => this.handleProposal(e)}
                  className="form-control selectbox dropdown-height-border"
                >
                  {options}
                </select>
              </li> */}
            <li>
              <input
                className="form-control mapsearch"
                placeholder={LocaleStrings.button_search}
                type="text"
                value={this.state.search}
                onChange={this.onSearchProposal}
              />
            </li>
            <li>
              <span className="pull-right">
                <button
                  type="button"
                  className="btn btn-custom-blue"
                  onClick={() =>
                    this.props.history.push("/dashboard/tickets/proposalwizard")
                  }
                >
                  <img
                    style={{ paddingRight: 8, paddingBottom: 3 }}
                    src="../../style/images/header-icons/plus.png"
                  ></img>
                  {LocaleStrings.button_create_new}
                </button>
              </span>
            </li>
          </ul>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <>
              {this.props.addReviewerModal.showModal ? <AddReviewer /> : ""}
              {this.props.showManageProposalModal.showModal ? (
                <ManageProposal history={this.props.history} />
              ) : (
                ""
              )}

              {proposalList &&
              proposalList.data &&
              proposalList.data.length > 0 ? (
                <div className="sponsor-table">
                  <table className="table ticketTable">
                    <thead>
                      <tr>
                        <th>{LocaleStrings.dashboard_proposal_name}</th>
                        <th>{LocaleStrings.dashboard_proposal_category}</th>
                        <th>{LocaleStrings.dashboard_form_live_status}</th>
                        <th>{LocaleStrings.dashboard_no_of_responses}</th>
                        <th style={{ paddingLeft: 90 }}>
                          {LocaleStrings.dashboard_action}
                        </th>
                      </tr>
                    </thead>
                    <tbody>{this.renderProposalList()}</tbody>
                  </table>
                  {this.props.proposalList.data &&
                  this.props.proposalList.count > 20 ? (
                    <Pagination
                      activePage={this.state.pageNumber}
                      itemsCountPerPage={20}
                      totalItemsCount={this.props.proposalList.count}
                      pageRangeDisplayed={10}
                      onChange={this.paginationCallback}
                      style={{ float: "right" }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              ) : this.state.search != "" ? (
                <div className="no-content-container">
                  <div className="no-content-message">
                    {LocaleStrings.proposal_text_no_proposals}
                  </div>
                </div>
              ) : (
                <div className="no-content-container">
                  <div className="no-content-message">
                    {LocaleStrings.proposal_text_no_proposals}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log('state.SettingData :- ', state.SettingData);
  return {
    deviceSize: state.deviceSize,
    session: state.session,
    proposalList: state.proposalList,
    addReviewerModal: state.addReviewerModal,
    showManageProposalModal: state.showManageProposalModal,
  };
}

export default connect(mapStateToProps, {
  fetchProposal,
  fetchEventDetails,
  fetchUsersCategory,
  openDashboardUserModal,
  editDashboardUser,
  searchProposal,
})(Dashboard);
